import React, { useState } from "react";
import SearchCompany from "../components/CompanySearch";
import CompanyInfo from "../components/CompanyInfo";
import { useData } from "../../services/context/DataContext";

const CompanyInfoPage: React.FC = () => {
  const { isBasicInfo } = useData();
  const [isAddCompanyInfo, setIsAddCompanyInfo] = useState<boolean>(isBasicInfo);
  return (
    <div>
      {isAddCompanyInfo ? (
        <CompanyInfo setIsAddCompanyInfo={setIsAddCompanyInfo} />
      ) : (
        <SearchCompany setIsAddCompanyInfo={setIsAddCompanyInfo} />
      )}
    </div>
  );
};
export default CompanyInfoPage;
